import { keepPreviousData, queryOptions } from '@tanstack/react-query';
import type { SessionClient } from '@portal/platform/http';
import { fetchLeads, fetchLeadTimeline } from './api';
import type { LeadsQuery } from './types';

/**
 * The leads queries. Not keyed on the org node: the default query scope resets them on a node or
 * view-mode switch (see `session-queries.ts`).
 */
export const leadsKeys = {
  lists: ['leads', 'list'] as const,
  list: (query: LeadsQuery) => ['leads', 'list', query] as const,
  timeline: (leadId: string) => ['leads', 'timeline', leadId] as const,
};

// `client` is the session's transport, not an input to the answer.
/* eslint-disable @tanstack/query/exhaustive-deps */

export const leadsListQueryOptions = (client: SessionClient, query: LeadsQuery) =>
  queryOptions({
    queryKey: leadsKeys.list(query),
    queryFn: () => fetchLeads(client, query),
    // The table keeps the previous page under its loading overlay instead of emptying.
    placeholderData: keepPreviousData,
  });

export const leadTimelineQueryOptions = (client: SessionClient, leadId: string) =>
  queryOptions({
    queryKey: leadsKeys.timeline(leadId),
    queryFn: () => fetchLeadTimeline(client, leadId),
  });

/* eslint-enable @tanstack/query/exhaustive-deps */
